<template>
  <FormFieldWrapper :data="data">
    <VAInput
      :modelValue="modelValue"
      @update:modelValue="handleInput"
      @blur="handleBlur"
      placeholder="example@email.com"
      :validateFunc="emailValidation"
      :error-message="errorMessage"
    />
  </FormFieldWrapper>
</template>

<script>
import FormFieldWrapper from './FormFieldWrapper.vue';

export default {
  name: 'Email',
  components: { FormFieldWrapper },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: String,
      default: ''
    },
    customValidation: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      errorMessage: '',
      shouldValidate: false
    };
  },
  emits: ['update:modelValue', 'blur', 'validation-error-changed'],
  computed: {
    emailValidation() {
      return (value) => {
        var isValid = true;
        if(this.shouldValidate){
          if (!value) return true;
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          isValid = emailRegex.test(value);
          if (this.customValidation) {
            isValid = this.customValidation(value) && isValid;
          }
        }
        if(!isValid){
          this.errorMessage = 'Please enter a valid email address';
        }
        this.$emit('validation-error-changed', !isValid);
        return isValid;
      };
    }
  },
  methods: {
    handleInput(value) {
      this.shouldValidate = false;
      this.$emit('update:modelValue', value);
    },
    handleBlur() {
      this.shouldValidate = true;
      this.$emit('blur', this.modelValue);
    }
  }
};
</script>

<style scoped>
</style>
